"use client";

import * as React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function StartYourRitual() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="236929" id="plan-your-custom-escape" className="relative flex min-h-[80vh] flex-col items-center justify-center overflow-hidden bg-secondary py-32 md:py-48 lg:py-64 dark">
      {}
      <div className="pointer-events-none absolute inset-0 z-0 flex items-center justify-center opacity-10">
        <div className="absolute h-[150vw] w-[150vw] animate-spin rounded-full bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623046/img/guizhou_topographic_pattern.png')] bg-repeat opacity-20 contain-layout md:h-[100vw] md:w-[100vw]" style={{
        animationDuration: "150s",
        WILL_CHANGE: "transform"
      } as React.CSSProperties} />
        <div className="absolute inset-0 bg-gradient-to-b from-secondary/20 to-secondary/20 shadow-[inset_0_0_100px_rgba(255,255,255,0.1)]" />
      </div>

      <div ref={ref} className={`relative z-10 mx-auto max-w-5xl px-6 text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        <h2 className="font-default text-5xl font-bold tracking-tight text-foreground sm:text-6xl md:text-7xl lg:text-8xl">
          Ready for a journey like no other?
        </h2>

        <div className="mt-16 md:mt-24">
          <Link to="#">
            <Button size="lg" className="h-14 rounded-full bg-primary px-10 text-lg font-medium text-primary-foreground shadow-xl transition-transform hover:scale-105 hover:bg-primary/90">
              Design Your Tour
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}
export default React.memo(StartYourRitual);